type BreakpointSizes = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const breakpoints: Record<BreakpointSizes, number> = Object.freeze({
  xs: 0,
  sm: 376,
  md: 768,
  lg: 1024,
  xl: 1440
});

export const getBreakpoint = (size: BreakpointSizes) => {
  return breakpoints[`${size}`];
};
